<template>
  <div class="container-fluid p-0 px-3 mx-auto">
    <custom-callout
      v-for="(document, index) in proposalDocuments"
      :key="`proposal-document-${index}`"
      class="custom-callout my-3 px-1"
    >
      <div class="row mx-auto p-3">
        <div class="col-12 col-md-4">
          <div class="font-14 color-gray-6">
            Documento:
          </div>
          <div class="font-14 color-black d-flex align-align-items-center">
            <span class="color-black font-16 mr-3">
              {{ documentTypeName(document) }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="font-14 color-gray-6">
            Archivo:
          </div>
          <div class="font-14 color-black d-flex align-align-items-center">
            <span class="color-black font-16 mr-3">
              {{ documentFilename(document) }}
            </span>
          </div>
        </div>
        <div
          class="col-12 col-md-4 d-flex justify-content-end align-items-center"
        >
          <action-button
            i="fas fa-file-download"
            variant="success"
            @click="onDownload(document)"
          />
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout.vue';
import ActionButton from 'ActionButton';
import _generalApi from '@/modules/app/api.js';
import { getServiceProposalDocuments as _getServiceProposalDocuments } from '@/modules/billingHistory/api';
import alert from '@/mixins/alert.mixin';
import documentTypes from '@/utils/shared/constants/documentTypes';

export default {
  name: 'EducativeServiceDocumentManagement',
  components: { CustomCallout, ActionButton },
  mixins: [alert],
  props: {
    requestId: {
      type: Number,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      proposalDocuments: [],
    };
  },
  computed: {
    documentTypeName() {
      return (document) => document?.documentType?.name ?? '-';
    },
    documentFilename() {
      return (document) => document?.filename ?? '-';
    },
  },
  async mounted() {
    const { data } = await _getServiceProposalDocuments(this.requestId);
    this.proposalDocuments = [...data];
  },
  methods: {
    async onDownload(document) {
      if (
        !document.documentId &&
        document.documentType.id !==
          documentTypes.TapRequestCartaAprobacionFirmada
      ) {
        this.ShowToast('', 'No contiene documento.', 'error');
        return;
      }

      try {
        if (
          document.documentType.id ===
          documentTypes.TapRequestCartaAprobacionFirmada
        ) {
          const params = {
            requestId: this.requestId,
          };
          await _generalApi.getTapRequestPurchaseService(params);
        }
        await _generalApi.downloadDocumentByAttachmentId(document.documentId);
      } catch {
        this.ShowToast('', 'El documento no existe.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
